module.exports = __webpack_public_path__ + "img/a5444f2.jpg";